import { LOCAL_COOKIE_ACCEPT_KEY } from "src/constants/global";

export const hasAcceptedCookies = () => localStorage.getItem(LOCAL_COOKIE_ACCEPT_KEY) === "true";

export const setAcceptedCookies = (state: boolean) => {
  localStorage.setItem(LOCAL_COOKIE_ACCEPT_KEY, state ? "true" : "false");
};
